module.exports = __webpack_public_path__ + "media/icons/wlasciciel-prywatna-white@2x-3c79b673.png";